module.exports = "mutation UpdateHotlineAnswerOrder($answers:[UpdateHotlineAnswerOrderInput]!){updateHotlineAnswerOrder(answers:$answers){success}}"